import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function ScrollToTop({ dark }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0, y: 20 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          onClick={scrollToTop}
          className={`fixed bottom-8 right-8 z-50 w-12 h-12 rounded-full shadow-lg backdrop-blur-md border-2 transition-all duration-300 group ${
            dark
              ? "bg-[#23244d]/80 border-indigo-400/50 hover:bg-[#23244d] hover:border-indigo-400"
              : "bg-white/80 border-indigo-500/50 hover:bg-white hover:border-indigo-500"
          }`}
          whileHover={{ scale: 1.1, y: -2 }}
          whileTap={{ scale: 0.95 }}
        >
          <motion.div
            className="flex items-center justify-center w-full h-full"
            animate={{ y: [0, -2, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          >
            <svg
              className={`w-6 h-6 transition-colors duration-300 ${
                dark ? "text-indigo-400" : "text-indigo-600"
              } group-hover:text-indigo-500`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 10l7-7m0 0l7 7m-7-7v18"
              />
            </svg>
          </motion.div>
          
          {/* Tooltip */}
          <motion.div
            initial={{ opacity: 0, x: 10 }}
            whileHover={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.2 }}
            className={`absolute right-full mr-3 px-3 py-1 rounded-lg text-sm font-medium whitespace-nowrap ${
              dark
                ? "bg-[#23244d] text-white border border-indigo-400/50"
                : "bg-white text-[#1b1c4e] border border-indigo-500/50 shadow-lg"
            }`}
          >
            Back to top
            <div
              className={`absolute top-1/2 -translate-y-1/2 left-full w-0 h-0 border-l-4 border-l-transparent ${
                dark
                  ? "border-l-[#23244d]"
                  : "border-l-white"
              }`}
              style={{ borderTop: "4px solid transparent", borderBottom: "4px solid transparent" }}
            />
          </motion.div>
        </motion.button>
      )}
    </AnimatePresence>
  );
} 